module.exports = __webpack_public_path__ + "static/media/referral-landing-frontground.7abf63a1.png";